import PendingAssetsCollection from '../pendingAssets';

export const pendingAssets = new PendingAssetsCollection([]);

export default pendingAssets;

import {setGlobal} from '@netx/core-next/utils/setGlobal';
if (process.env.NODE_ENV !== 'production') {
	setGlobal({pendingAssets});
}
